"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const esprima = __importStar(require("esprima"));
const escodegen = __importStar(require("escodegen"));
const acorn = __importStar(require("acorn"));
const astring = __importStar(require("astring"));
function default_1(config) {
    config = getDefaultsFor(config);
    let ast;
    let output;
    if (config.parser === 'esprima') {
        ast = esprima.parseScript(config.code);
    }
    else {
        ast = acorn.parse(config.code, config.acornOptions);
    }
    if (config.generator === 'escodegen') {
        output = escodegen.generate(ast, {
            format: escodegen.FORMAT_MINIFY
        }) || config.code;
    }
    else {
        output = astring.generate(ast) || config.code;
    }
    return output;
}
exports.default = default_1;
function getDefaultsFor(config) {
    config.parser = config.parser || 'esprima';
    config.generator = config.generator || 'escodegen';
    config.esprimaOptions = config.esprimaOptions || {};
    config.esprimaOptions.tolerant = typeof config.esprimaOptions.tolerant === 'boolean' ? config.esprimaOptions.tolerant : true;
    config.acornOptions = config.acornOptions || {};
    config.acornOptions.ecmaVersion = config.acornOptions.ecmaVersion || '7';
    config.acornOptions.sourceType = config.acornOptions.sourceType || 'script';
    return config;
}
//# sourceMappingURL=index.js.map